var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[[_vm._v(_vm._s(`${_vm.val != 0 ? '是' : '否'}`))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }